/* eslint-disable */
import * as React from 'react';
import { useCalendarValue } from './hooks/useCalendarValue';
import { useCalendarMultiple } from './hooks/useCalendarMultiple';
import { useCalendarOpenState } from './hooks/useCalendarOpenState';
import { useCalendarDisplayValue } from './hooks/useCalendarDisplayValue';
import { CalendarSelectorPropsType } from './types';
import { useCalendarCurrentGroup } from './hooks/useCalendarCurrentGroup';
import { useCalendarGroups } from './hooks/useCalendarGroups';
import { useSelectAll } from './hooks/useSelectAll';
import { useUnselectAll } from './hooks/useUnselectAll';
import { useApplay } from './hooks/useApplay';
import { useCancel } from './hooks/useCancel';
import { useSelectToggle } from './hooks/useSelectToggle';
import { useCalendar } from './hooks/useCalendar';

export const CalendarSelector: React.FC<CalendarSelectorPropsType & { props?: Record<string, unknown> }> = props => {
  const multiple = useCalendarMultiple();
  const context = useCalendar();
  const [openState, toggleOpenState] = useCalendarOpenState();
  const [value, setValue] = useCalendarValue();
  const [groups, updateGroups] = useCalendarGroups();
  const [currentGroup, prevGroup, nextGroup] = useCalendarCurrentGroup(groups);
  const selectAll = useSelectAll(groups, updateGroups);
  const unselectAll = useUnselectAll(groups, updateGroups);
  const applay = useApplay(groups, setValue);
  const cancel = useCancel(groups, updateGroups);
  const select = useSelectToggle(groups, updateGroups);
  const Component = props.component;
  const componentProps = props.props || {};
  const onSelect = componentProps['onSelect'] as undefined | ((value: string | string[] | null) => void);
  const handleSelect = React.useCallback((value: string | string[] | null) => {
    if (value !== null) {
      select(value);
      if (onSelect) {
        onSelect(value);
      }
    }
  }, [select, onSelect]);
  return React.useMemo(() => (
    <Component
      groupSize={context.groupSize}
      openState={openState}
      currentGroup={currentGroup}
      nextGroup={nextGroup}
      prevGroup={prevGroup}
      selectAll={selectAll}
      unselectAll={unselectAll}
      select={handleSelect}
      applay={applay}
      cancel={cancel}
      value={value}
      groups={groups}
      multiple={multiple}
      onChange={setValue}
      onToggleOpenState={toggleOpenState}

      {...componentProps}
    />
  ), [openState, currentGroup, JSON.stringify(value), groups, multiple, props.props, nextGroup, prevGroup, applay, handleSelect]);
}
